module.exports = __webpack_public_path__ + "files/160e683aa291bea9c0f479d569f8cb7c.svg";